/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personas_No_Personas_DescriptionInputs */



/**
* | output |
* | --- |
* | "Create AI personas to provide predefined behavior instructions that users can activate in their projects." |
*
* @param {Personas_No_Personas_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_no_personas_description = /** @type {((inputs?: Personas_No_Personas_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_No_Personas_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen Sie KI-Personas, um vordefinierte Verhaltensanweisungen bereitzustellen, die Benutzer in ihren Projekten aktivieren können.")
	return /** @type {LocalizedString} */ ("Create AI personas to provide predefined behavior instructions that users can activate in their projects.")
});